<div class="uploadCSVPhoneNumberFiles up">
  <div class="uploadFileCard up__card">
    <header class="up__head">
      <h3 class="bk-section-title up__title">Upload a file of phone numbers</h3>
      <p class="up__sub">
        CSV, Excel or another spreadsheet, up to {{ MAX_CONTACTS.toLocaleString() }} rows.
        One column must hold the numbers; you pick which on the next step.
      </p>
    </header>

    <!-- drop zone -->
    <div
      class="fileUploadArea up__drop"
      [class.is-dragging]="isHovering"
      [class.has-file]="tableData.length > 0 && !loading"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      @if (loading) {
      <div class="loadingState up__state" role="status">
        <span class="bk-sym up__icon" aria-hidden="true">description</span>
        <span class="bk-skel up__skel" aria-hidden="true"></span>
        <p class="up__lead">Reading {{ fileName || 'file' }}…</p>
      </div>
      } @else if (!tableData.length) {
      <div class="noFile up__state">
        <span class="bk-sym up__icon" aria-hidden="true">upload_file</span>
        <p class="up__lead">Drop the file here</p>
        <p class="up__hint">or</p>
        <input
          type="file"
          id="csvUpload"
          class="up__input"
          (change)="onFileSelected($event)"
          (drop)="onFileSelected($event)"
          [accept]="acceptedFormats"
        />
        <label for="csvUpload" class="bk-btn bk-btn--primary up__browse">
          <span class="bk-sym" aria-hidden="true">folder_open</span>
          Choose a file
        </label>
      </div>
      } @else {
      <div class="fileUploaded up__state">
        <span class="bk-sym up__icon" aria-hidden="true">task</span>
        <p class="fileName up__file">{{ fileName }}</p>
        <p class="up__hint">{{ tableData.length.toLocaleString() }} rows read</p>
        <div class="up__actions">
          <input
            type="file"
            id="changeFile"
            class="up__input"
            (change)="onFileSelected($event)"
            [accept]="acceptedFormats"
          />
          <label for="changeFile" class="bk-btn bk-btn--ghost">Choose another file</label>
          <button type="button" class="bk-btn bk-btn--primary" (click)="continue()">
            Continue
          </button>
        </div>
      </div>
      }
    </div>

    <!-- error -->
    @if (errorMessage) {
    <p class="errorMessage up__error" role="alert">
      <span class="up__dot" aria-hidden="true"></span>
      <span>{{ errorMessage }}</span>
    </p>
    }

    @if (!tableData.length && !loading) {
    <a href="/files/csv-phoneNumbers-template.csv" download class="bk-more up__sample">
      <span class="bk-sym" aria-hidden="true">download</span>
      Download a sample file
    </a>
    }
  </div>
</div>
